module.exports = __webpack_public_path__ + "img/OrsolyaSzegedi.ceb6ed1.png";